var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitorsLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2496 16.6666V13.75C17.1546 13.75 17.6659 13.75 17.8488 13.3547C18.0317 12.9596 17.8294 12.419 17.4246 11.338L16.3896 8.57406C16.0476 7.66042 15.3482 7.08331 14.5833 7.08331C13.8184 7.08331 13.1191 7.66042 12.777 8.57406L11.7421 11.338C11.3372 12.419 11.1349 12.9596 11.3178 13.3547C11.5007 13.75 12.0111 13.75 12.9162 13.75V16.6666C12.9162 17.4523 12.9162 17.8451 13.1603 18.0892C13.4044 18.3333 13.7972 18.3333 14.5829 18.3333C15.3686 18.3333 15.7614 18.3333 16.0055 18.0892C16.2496 17.8451 16.2496 17.4523 16.2496 16.6666Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 3.33335C7.08333 4.25383 6.33714 5.00002 5.41667 5.00002C4.49619 5.00002 3.75 4.25383 3.75 3.33335C3.75 2.41288 4.49619 1.66669 5.41667 1.66669C6.33714 1.66669 7.08333 2.41288 7.08333 3.33335Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 3.33335C16.2501 4.25383 15.5039 5.00002 14.5834 5.00002C13.6629 5.00002 12.9167 4.25383 12.9167 3.33335C12.9167 2.41288 13.6629 1.66669 14.5834 1.66669C15.5039 1.66669 16.2501 2.41288 16.2501 3.33335Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74992 10.4166C8.74992 8.84531 8.74992 8.05962 8.26176 7.57147C7.77361 7.08331 6.98794 7.08331 5.41659 7.08331C3.84524 7.08331 3.05956 7.08331 2.57141 7.57147C2.08325 8.05962 2.08325 8.84531 2.08325 10.4166V12.0833C2.08325 12.869 2.08325 13.2618 2.32733 13.5059C2.57141 13.75 2.96424 13.75 3.74992 13.75V16.6666C3.74992 17.4523 3.74992 17.8451 3.99399 18.0892C4.23808 18.3333 4.63091 18.3333 5.41659 18.3333C6.20226 18.3333 6.59509 18.3333 6.83918 18.0892C7.08325 17.8451 7.08325 17.4523 7.08325 16.6666V13.75C7.86893 13.75 8.26176 13.75 8.50584 13.5059C8.74992 13.2618 8.74992 12.869 8.74992 12.0833V10.4166Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorsLog);
export default __webpack_public_path__ + "static/media/visitors-log.ed64f32ceae2a3bb43a9009534b5bac1.svg";
export { ForwardRef as ReactComponent };